import { IUser } from 'app/services/user';
import DeleteButton from 'Components/Buttons/DeleteButton';
import UserAvatarList from 'Components/UserAvatarList';
import UserBox from 'Components/UserBox';
import { ReactNode } from 'react';

export default function UsersList({
  users,
  right,
  content,
  onDelete,
  collapse = false,
}: {
  users: IUser[];
  content?: (user: IUser) => ReactNode;
  right?: (user: IUser) => ReactNode;
  onDelete?: (user: IUser) => void;
  collapse?: boolean;
}) {
  return (
    <>
      {users.map((user) => (
        <div className="border-b border-gray-800" key={user.id}>
          <UserBox
            theme={'white'}
            px="4"
            shadow=""
            py="2"
            user={user}
            right={onDelete && <DeleteButton onClick={() => onDelete(user)} />}
            content={content && content(user)}
          />
        </div>
      ))}
    </>
  );
}
